export default "__VITE_ASSET__D8ljanxK__"